import { NotificationOutlined, PlusCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  ColProps,
  Form,
  Input,
  Modal as AntModal,
  Row,
  RowProps,
  Select,
  Spin,
  Typography,
  PaginationProps,
  Pagination,
  message,
  Card,
} from "antd";
import { useEffect, useMemo, useState } from "react";
import UserCard from "src/components/UserCard/UserCard";
import { companyUserStore } from "src/stores/company-user-store";
import { useShallow } from "zustand/react/shallow";
import ManageUserTable from "./components/ManageUserTable";
import { roleStore } from "src/stores/role-store";
import { useDidMount } from "src/hook/useDidMount";
import { UserStateProps } from "src/entity/user-management/users-state.entity";
import { cloneDeep, omit, uniqueId } from "lodash";
import { BodyCreateWithAssign } from "src/entity/map-company-user/map-company-user";
import { CompanyRole, ResponseGetUserManagement } from "src/entity/map-company-user/user-in-company";
import { SearchUser } from "./components/SearchUsers";
import { generateErrorMessage } from "src/utils/error-message";
import { profileStore } from "src/stores/profile-store";
import { CommonSuccess } from "src/entity/common/menus-enum.enum";
import { NormalError } from "src/entity/common/bad-request.enum";
import VocsModal from "src/components/Modal";
import { companyStore } from "src/stores/company-store";
import VerticalCenter from "src/components/WrapCenter/VerticalCenter";
import { FiAlertCircle } from "react-icons/fi";
import FormLabel from "src/components/AntdCustomPart/FormLabel/FormLabel";
import { componentPalette } from "src/theme/component-palette";
import "./components/ManageUserTable.css";
import { parseErrorString } from "src/utils/utils-object";
import { useNavigate } from "react-router-dom";
import { RolesEnum, RolesNameEnum } from "src/entity/common/roles.enum";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import MaskScreen from "src/components/MaskScreen";

const { Text } = Typography;
const rowProps: RowProps = {
  gutter: {
    xs: 0,
    md: 12,
  },
};

const colProps: ColProps = {
  xs: { span: 24 },
  md: { span: 12 },
};
const SettingUserManagement = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const navigator = useNavigate();
  const [visibleModal, setVisibleModal] = useState<boolean>(false);
  const [manageUsers, setManageUsers] = useState<UserStateProps[]>([]);
  const [userForm] = Form.useForm();
  const [roleCompanyForm] = Form.useForm();
  const [textSearch, setTextSearch] = useState("");
  const [filterRole, setFilterRole] = useState<string[]>([]);
  const [filterCompany, setFilterCompany] = useState<string[]>([]);
  const [isEditingData, setIsEditingData] = useState<string>("");
  const [page, setPage] = useState(1);
  const [pageSize, _] = useState(10);
  const [visibleWarning, setVisibleWarning] = useState(false);

  const getProfile = profileStore(useShallow((state) => state.requestProfile));
  const loadingProfile = profileStore(useShallow((state) => state.loading));
  const profile = profileStore(useShallow((state) => state.profile));
  const company = profile?.company ?? [];
  const getFilterAdminUsrManagement = companyStore(useShallow((state) => state.getFilterAdminUsrManagement));
  const dataFilterCompany = companyStore(useShallow((state) => state.dataFilterCompany));
  const dataUnAssignRole = companyStore(useShallow((state) => state.dataUnAssignRole));
  const getUnAssignRole = companyStore(useShallow((state) => state.getUnAssignRoleInCompany));
  const getUserManagement = companyUserStore(useShallow((state) => state.requestUserManagement));
  const userIncompany = companyUserStore(useShallow((state) => state.userInCompany));
  const loadingUser = companyUserStore(useShallow((state) => state.loadingUserInCompany));
  const loadingManageUser = companyUserStore(useShallow((state) => state.loadingManageUser));
  const createWithAssign = companyUserStore(useShallow((state) => state.requestCreateWithAssign));
  const requestUpdateWithAssign = companyUserStore(useShallow((state) => state.requestUpdateWithAssign));
  const requestDeleteUser = companyUserStore(useShallow((state) => state.requestDeleteUser));
  const loadingDelete = companyUserStore(useShallow((state) => state.loadingDeleteUser));
  const errorMessage = companyUserStore(useShallow((state) => state.error));
  const clearError = companyUserStore(useShallow((state) => state.clearError));
  // const { nuts, honey } = useBearStore(useShallow((state) => ({ nuts: state.nuts, honey: state.honey })));
  const {
    getAllCompanyRoleByUserId,
    loadingCompanyUserById,
    dataGetUserById,
    clearDataGetUserById,
    getCompanyIamCompanyAdmin,
    dataIamCompanyAdmin,
    clearDataIamCompanyAdmin,
  } = companyUserStore(
    useShallow((state) => ({
      getAllCompanyRoleByUserId: state.getAllCompanyRoleByUserId,
      loadingCompanyUserById: state.loadingCompanyUserById,
      dataGetUserById: state.dataGetUserById,
      clearDataGetUserById: state.clearDataGetUserById,
      getCompanyIamCompanyAdmin: state.getCompanyIamCompanyAdmin,
      dataIamCompanyAdmin: state.dataIamCompanyAdmin,
      clearDataIamCompanyAdmin: state.clearDataIamCompanyAdmin,
    })),
  );
  const roles = roleStore(useShallow((state) => state.data));
  const getAllRoles = roleStore(useShallow((state) => state.getAllRoles));

  // console.log("dataGetUserById : ", dataGetUserById);

  useDidMount(() => {
    getAllRoles();
    getUserManagement({ page, limit: pageSize });
    getUnAssignRole();
    getFilterAdminUsrManagement();
  });

  const isWarningRole = useMemo(() => {
    if (!dataUnAssignRole || !Array.isArray(dataUnAssignRole)) return false;

    if (dataUnAssignRole.some((item) => item.unAssignRole?.length)) return true;
  }, [dataUnAssignRole]);

  const closeUserModal = () => {
    setVisibleModal(false);
    setIsEditingData("");
    userForm.resetFields();
    roleCompanyForm.resetFields();
    clearDataGetUserById();
    clearDataIamCompanyAdmin();
    clearError();
    setManageUsers([]);
  };

  const openUserModal = async () => {
    setVisibleModal(true);
    await getCompanyIamCompanyAdmin();
  };

  const onAddUser = async () => {
    const tmpManageUsers = [...manageUsers];
    const uniqKey = uniqueId("new_user_");
    const compVal = company ? company[0]._id : "";
    const useageRoles = roles?.filter((item) => item.roleValue !== RolesEnum.SYSTEM_ADMIN);
    const roleVal = useageRoles ? useageRoles[0]._id : "";
    const isActive = true;
    tmpManageUsers.push({
      key: uniqKey,
      company: compVal,
      role: roleVal,
      isActive: isActive,
    });
    roleCompanyForm.setFieldsValue({
      [`company-${uniqKey}`]: compVal,
      [`role-${uniqKey}`]: roleVal,
      [`isActive-${uniqKey}`]: isActive,
    });
    setManageUsers(tmpManageUsers);
  };
  // console.log("[Render] dataGetUserId : ", dataGetUserById);
  // const [reRender, setReRender] = useState(false);
  const onClickUserCard = async (item: ResponseGetUserManagement, index: number) => {
    setVisibleModal(true);
    await getAllCompanyRoleByUserId(item._id[0]).then((rawData) => {
      const parseResult = cloneDeep(rawData);
      const result = { ...parseResult?.data };
      // const companyAdminInside = [...(rawData?.companyAdminIn ? rawData?.companyAdminIn.map((e) => e.company) : [])];
      const activeCompanyAdminInside = [
        ...(rawData?.companyAdminIn ? rawData?.companyAdminIn.filter((e) => e.isActive).map((e) => e.company) : []),
      ];
      result.companyRole = profile?.isSystemAdmin
        ? rawData?.data?.companyRole
        : profile?.userId === item._id[0]
          ? rawData?.data?.companyRole.filter((e) => activeCompanyAdminInside.includes(e._id[0]))
          : rawData?.data?.companyRole.filter((e) => activeCompanyAdminInside.includes(e._id[0]));

      // result.companyRole?.forEach((companyRole) => {
      //   companyRole.roles = profile?.isSystemAdmin
      //     ? companyRole.roles
      //     : companyRole.roles.filter((r) => r.roleValue !== RolesEnum.SYSTEM_ADMIN);
      // });

      if (result)
        userForm.setFieldsValue({
          name: result.name,
          email: result.email,
        });
      const tmpManageUsers = [...manageUsers];

      (result?.companyRole as CompanyRole[]).forEach((companyRole) => {
        companyRole.roles.forEach((e) => {
          const uniqKey = uniqueId("update_user_");
          if (e.roleValue === RolesEnum.SYSTEM_ADMIN) {
            if (profile?.isSystemAdmin) {
              tmpManageUsers.push({
                key: uniqKey,
                company: companyRole._id[0],
                role: e._id[0],
                isActive: e.activeRoleCompany,
              });
              roleCompanyForm.setFieldsValue({
                [`company-${uniqKey}`]: companyRole._id,
                [`role-${uniqKey}`]: e._id,
                [`isActive-${uniqKey}`]: e.activeRoleCompany,
              });
            }
          } else {
            tmpManageUsers.push({
              key: uniqKey,
              company: companyRole._id[0],
              role: e._id[0],
              isActive: e.activeRoleCompany,
            });
            roleCompanyForm.setFieldsValue({
              [`company-${uniqKey}`]: companyRole._id,
              [`role-${uniqKey}`]: e._id,
              [`isActive-${uniqKey}`]: e.activeRoleCompany,
            });
          }
        });
      });

      setIsEditingData(item._id[0]);
      setManageUsers(tmpManageUsers);
    });
  };

  const onUpdateKeyVal = async (row: string, field: keyof UserStateProps, value: string | boolean) => {
    const tmpManageUsers = [...manageUsers];
    const targetIndex = tmpManageUsers.findIndex((item) => item.key === row);
    if (targetIndex !== -1) {
      tmpManageUsers[targetIndex][field] = value as never;
    }
    // console.log(tmpManageUsers);
    setManageUsers(tmpManageUsers);
  };

  const onDeleteCompanyRole = (index: number | string) => {
    const tmpManageUsers = [...manageUsers];
    tmpManageUsers.splice(+index, 1);
    setManageUsers(tmpManageUsers);
  };

  useEffect(() => {
    if (manageUsers && manageUsers?.length) {
      validateCompanyRole();
    }
  }, [manageUsers]);

  const validateCompanyRole = async () => {
    await roleCompanyForm.validateFields().catch((err) => console.log());
  };

  const submitCreateForm = async () => {
    let isUserFormError = false;
    let isRoleCompanyError = false;
    await userForm.validateFields().catch(() => {
      isUserFormError = true;
    });
    await roleCompanyForm.validateFields().catch(() => {
      isRoleCompanyError = true;
    });

    if (isUserFormError || isRoleCompanyError) return;
    const profileValue = userForm.getFieldsValue();
    const mappedValues = [...manageUsers];
    const finalLists: BodyCreateWithAssign[] = [];
    finalLists.push({
      name: profileValue.name,
      email: profileValue.email,
      isActive: true,
      companyRole: [],
    });
    // console.log("mappedValues :: ", mappedValues);
    mappedValues.forEach((item) => {
      finalLists[0].companyRole.push({
        roleId: item.role,
        companyId: item.company,
        isActive: item.isActive,
      });
    });

    // console.log("Before merge :: ", finalLists);
    if (!profile?.isSystemAdmin && isEditingData) {
      // merge other mapCompanyUser to finalLists
      if (isEditingData === profile?.userId) {
        // For Company Admin -> merge Inactive System Admin to final data.
        const findInActiveSystemAdmin = dataGetUserById?.data?.companyRole.find((item) =>
          item.roles.some((ro) => ro.roleValue === RolesEnum.SYSTEM_ADMIN && !ro.activeRoleCompany),
        );
        if (findInActiveSystemAdmin) {
          findInActiveSystemAdmin.roles.forEach((ro) => {
            if (ro.roleValue === RolesEnum.SYSTEM_ADMIN)
              finalLists[0].companyRole.push({
                roleId: ro._id[0],
                companyId: findInActiveSystemAdmin._id[0],
                isActive: ro.activeRoleCompany,
              });
          });
        }

        // For Company Admin -> merge inactive Company Admin to final data.
        const findInActiveCompanyAdmin = dataGetUserById?.data?.companyRole.filter((item) =>
          item.roles.some((ro) => ro.roleValue === RolesEnum.COMPANY_ADMIN && !ro.activeRoleCompany),
        );
        if (findInActiveCompanyAdmin && findInActiveCompanyAdmin?.length > 0) {
          findInActiveCompanyAdmin.forEach((item) => {
            item.roles.forEach((ro) => {
              if (ro.roleValue === RolesEnum.COMPANY_ADMIN && !ro.activeRoleCompany)
                finalLists[0].companyRole.push({
                  roleId: ro._id[0],
                  companyId: item._id[0],
                  isActive: ro.activeRoleCompany,
                });
            });
          });
        }
      } else {
        const listsCompanyAdmin = dataGetUserById?.companyAdminIn.filter((item) => item.isActive).map((e) => e.company);
        const dataGetUserByIdTmp = dataGetUserById?.data?.companyRole.filter((item) => !listsCompanyAdmin?.includes(item._id[0]));
        // console.log("dataGetUserByIdTmp :: ", dataGetUserByIdTmp);

        dataGetUserByIdTmp?.forEach((item) => {
          item.roles.forEach((r) => {
            finalLists[0].companyRole.push({
              roleId: r._id[0],
              companyId: item._id[0],
              isActive: r.activeRoleCompany,
            });
          });
        });

        // Note : must be find SYSTEM ADMIN ROLE for get merge too.
        const findSystemAdmin = dataGetUserById?.data?.companyRole.find((item) =>
          item.roles.some((ro) => ro.roleValue === RolesEnum.SYSTEM_ADMIN),
        );
        // console.log("[Update Other Peron] findSystemAdmin : ", { findSystemAdmin, dataGetUserById });
        if (findSystemAdmin) {
          findSystemAdmin.roles.forEach((ro) => {
            if (ro.roleValue === RolesEnum.SYSTEM_ADMIN)
              finalLists[0].companyRole.push({
                roleId: ro._id[0],
                companyId: findSystemAdmin._id[0],
                isActive: ro.activeRoleCompany,
              });
          });
        }
      }
    }
    // console.log("Final data update user : ", finalLists);
    if (isEditingData) requestUpdateWithAssign({ ...finalLists[0], _id: isEditingData }).then(fetchAfterActionUsers);
    else createWithAssign(finalLists[0]).then(fetchAfterActionUsers);
  };

  const onDeleteUser = async () => {
    const confirm = await VocsModal.delete({
      message: "",
    });

    if (!confirm) return;
    requestDeleteUser(isEditingData).then(() => fetchAfterActionUsers());
  };

  const fetchAfterActionUsers = async (response?: unknown) => {
    // console.log("Response Create : ", response);
    if (response && typeof response === "string" && response.includes("[")) {
      const formValues = roleCompanyForm.getFieldsValue();
      const roleListFromError = parseErrorString(response);
      let errorStateKey: string[] = [];
      manageUsers.forEach((item) => {
        const companyRoleTmp = `${item.company}-${item.role}`;
        if (roleListFromError.includes(companyRoleTmp)) {
          errorStateKey.push(item.key);
        }
      });
      for (const key in formValues) {
        const splitKey = key.split("-")[1];
        if ((key.includes("role") || key.includes("company")) && errorStateKey.includes(splitKey)) {
          roleCompanyForm.setFields([
            {
              name: key,
              errors: [NormalError.DuplicateRole], // Remove errors
            },
          ]);
        }
      }
      return;
    } else if (typeof response === "string" && response.includes(NormalError.USER_ALREADY_EXIST)) {
      userForm.setFields([
        {
          name: "name",
          errors: [""],
        },
        {
          name: "email",
          errors: [""],
        },
      ]);
    } else if (typeof response === "string") {
      return;
    } else {
      messageApi.open({
        type: "success",
        content: CommonSuccess.SAVED_SUCCESSFULL,
      });
      // Case : update myself role -> refresh profile
      const listAdminRole = roles
        ?.filter((item) => item.roleName === RolesNameEnum.SYSTEM_ADMIN || item.roleName === RolesNameEnum.COMPANY_ADMIN)
        .map((item) => item._id);

      // Case : [System, Company]Admin Role in current company
      const checkIsAdminRole = manageUsers.find(
        (item) => item.company === profile?.activeCompany._id && item.isActive && listAdminRole?.includes(item.role),
      );
      // Case : [System] Admin Role in other company
      const masterSystemAdminObject = roles?.find((item) => item.roleName === RolesNameEnum.SYSTEM_ADMIN);
      const checkIsSystemAdminForOtherCompany = manageUsers.find(
        (item) => item.isActive && item.role == masterSystemAdminObject?._id.toString(),
      );
      if (isEditingData && isEditingData === profile?.userId) {
        const result = await getProfile({ companyId: profile?.activeCompany._id }).then(() => {
          if (!checkIsAdminRole && !checkIsSystemAdminForOtherCompany) {
            navigator("/");
            closeUserModal();
            return "home";
          }
        });
        if (result && result === "home") return;
      }
      closeUserModal();
      setPage(1);
      getUnAssignRole();
      getFilterAdminUsrManagement();
      getUserManagement({
        textSearch,
        page: 1,
        limit: pageSize,
        roles: filterRole as string[],
        company: filterCompany as string[],
      });
    }
  };

  const onChangePage = (val: number) => {
    setPage(val);
    getUserManagement({
      page: val,
      limit: pageSize,
      textSearch,
      roles: filterRole as string[],
      company: filterCompany as string[],
    });
  };

  const paginationProps: PaginationProps = {
    size: "small",
    pageSize: pageSize,
    current: page,
    total: userIncompany.total || 0,
    defaultCurrent: 1,
    onChange: onChangePage,
    showSizeChanger: false,
  };

  // console.log("text serarch : ", textSearch);
  // console.log("filter group : ", { filterCompany, filterRole });
  // console.log("Data get UnAssign Role : ", dataUnAssignRole);
  // console.log("[Usr Management] profile : ", profile);
  // console.log("[Usr Management] dataIamCompanyAdmin : ", dataIamCompanyAdmin);

  return (
    <Row className="w-full">
      {contextHolder}
      {loadingProfile && <MaskScreen />}

      <Row className="w-full" justify={"space-between"}>
        <div></div>
        <div className="flex flex-row justify-between" style={{ width: "25vw" }}>
          <SearchUser
            placeholder="search text"
            roles={roles}
            pageSize={pageSize}
            setPage={setPage}
            company={dataFilterCompany}
            action={getUserManagement}
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            filterRole={filterRole}
            setFilterRole={setFilterRole}
            filterCompany={filterCompany}
            setFilterCompany={setFilterCompany}
          />
          {isWarningRole && (
            <Button
              className="flex items-center ml-2"
              danger
              type="primary"
              style={{ background: componentPalette.redFifth, borderColor: componentPalette.redThird }}
              onClick={() => setVisibleWarning(true)}
            >
              <FiAlertCircle size={24} color={componentPalette.redSecond} />
            </Button>
          )}
        </div>

        <Button type="primary" size={"middle"} className="flex items-center mr-4" onClick={openUserModal}>
          <PlusCircleOutlined />
          New
        </Button>
      </Row>
      <AntModal
        centered
        closeIcon={null}
        open={visibleWarning}
        onCancel={() => setVisibleWarning(false)}
        width={"50vw"}
        footer={null}
        style={{ backgroundColor: "transparent" }}
        className={"transparent-modal"}
      >
        <Row className="w-full" justify={"center"}>
          <Card className="w-full" style={{ background: componentPalette.redFourth, borderColor: componentPalette.redThird }}>
            <Row>
              <Col span={1}>
                <VerticalCenter>
                  <FiAlertCircle size={24} color={componentPalette.redThird} />
                </VerticalCenter>
              </Col>
              <Col span={23} className="pl-2">
                {dataUnAssignRole.map((comp, i) => {
                  if (comp.unAssignRole?.length)
                    return (
                      <Row key={"wrap-warning-" + i}>
                        {comp.unAssignRole.map((rol, index) => {
                          return (
                            <Text key={"text-warning-" + index}>
                              {rol.roleName + (index === comp.unAssignRole.length - 1 ? "" : ",\u00A0")}
                            </Text>
                          );
                        })}
                        <Text>{"\u00A0in " + comp.companyName + " is empty."}</Text>
                      </Row>
                    );
                  else return <div key={"wrap-warning-empty-" + i}></div>;
                })}
              </Col>
            </Row>
          </Card>
        </Row>
      </AntModal>
      <Row className="w-full pt-4" gutter={[16, 16]}>
        {loadingUser || !userIncompany.data ? (
          <div className="flex justify-center w-full">
            <Spin className="text-center"></Spin>
          </div>
        ) : (
          userIncompany.data.map((item, index) => {
            return (
              <Col xs={{ span: 24 }} md={{ span: 12 }} key={`user-card-${index}`} onClick={() => onClickUserCard(item, index)}>
                <UserCard user={omit(item, ["companyRole"])} companyRole={item.companyRole} />
              </Col>
            );
          })
        )}
      </Row>
      <Row className="w-full mt-4" justify={"end"}>
        <Pagination {...paginationProps} />
      </Row>

      <AntModal
        title={<ModalTitle title="User Management" />}
        open={visibleModal}
        width={1000}
        onCancel={closeUserModal}
        maskClosable={false}
        footer={
          <Row className="w-full pt-4 border-t" justify={"space-between"}>
            <Button key="back" disabled={isEditingData ? false : true} type="primary" danger loading={loadingDelete} onClick={onDeleteUser}>
              Delete
            </Button>
            <Button
              disabled={!manageUsers || manageUsers?.length === 0 ? true : false}
              key="submit"
              type="primary"
              loading={loadingManageUser}
              onClick={submitCreateForm}
            >
              Save
            </Button>
          </Row>
        }
        centered
      >
        <Spin spinning={loadingCompanyUserById}>
          {errorMessage && (
            <Row className="w-full" justify={"center"}>
              <Text type="danger">{errorMessage.includes("Duplicate Role") ? NormalError.DuplicateRole : errorMessage}</Text>
            </Row>
          )}
          <Form
            form={userForm}
            name="user-management"
            layout={"vertical"}
            requiredMark={false}
            onFieldsChange={(fields) => {
              // console.log("Fields was changed : ", fields);
              const fieldChange = fields[0]?.name[0] ?? "";
              if (
                errorMessage &&
                errorMessage.includes(NormalError.USER_ALREADY_EXIST) &&
                (fieldChange == "name" || fieldChange === "email")
              ) {
                clearError();
                userForm.setFields([
                  {
                    name: "name",
                    errors: undefined,
                  },
                  {
                    name: "email",
                    errors: undefined,
                  },
                ]);
              }
            }}
          >
            <Row {...rowProps}>
              <Col {...colProps}>
                <Form.Item
                  name="name"
                  label={<FormLabel label={"Name"} required />}
                  rules={[
                    {
                      required: true,
                      message: generateErrorMessage("Name"),
                    },
                    {
                      pattern: new RegExp(/^[\u0E01-\u0E2E\u0E30-\u0E4E\u0041-\u005A\u0061-\u007A\s]*$/),
                      message: "Allowed only character.",
                    },
                  ]}
                >
                  <Input maxLength={50} />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="email"
                  label={<FormLabel label={"Email"} required />}
                  rules={[
                    {
                      pattern: new RegExp(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      ),
                      message: "Invalid email format.",
                    },
                    {
                      required: true,
                      message: generateErrorMessage("Email"),
                    },
                  ]}
                >
                  <Input maxLength={50} disabled={isEditingData ? true : false} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <ManageUserTable
            roles={roles}
            company={company}
            onAddUser={onAddUser}
            manageUsers={manageUsers}
            roleCompanyForm={roleCompanyForm}
            onUpdateKeyVal={onUpdateKeyVal}
            onDeleteCompanyRole={onDeleteCompanyRole}
            errorMessage={errorMessage}
            clearError={clearError}
            isSystemAdmin={profile?.isSystemAdmin as boolean}
            activeCompanyId={profile?.activeCompany?._id as string}
            isEditUser={isEditingData}
            activeUser={profile?.userId}
            companyAdminIn={dataGetUserById?.companyAdminIn || dataIamCompanyAdmin}
          />
        </Spin>
      </AntModal>
    </Row>
  );
};

export default SettingUserManagement;
